import { useEffect, useState } from 'react';

import type { State } from '@crehana/ui/dist/styles/states';

const useSnackbarMessage = () => {
  const [{ isOpen, message, state, isDark }, setSnackbarState] = useState<{
    isOpen: boolean;
    message: string;
    state?: State;
    isDark?: boolean;
  }>({
    isOpen: false,
    message: '',
    state: 'info',
    isDark: false,
  });

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setSnackbarState(snackbarState => ({
          ...snackbarState,
          isOpen: !isOpen,
        }));
      }, 5000);
    }
  }, [isOpen]);

  const openSnackbar = ({
    msg,
    type,
    darkMode,
  }: {
    msg: string;
    type?: State;
    darkMode?: boolean;
  }) => {
    setSnackbarState(snackbarState => ({
      ...snackbarState,
      isOpen: true,
      message: msg,
      state: type,
      isDark: darkMode,
    }));
  };

  return {
    openSnackbar,
    isOpen,
    message,
    state,
    isDark,
  };
};

export default useSnackbarMessage;
